import React from "react";
import {useSelector} from "react-redux";
import {css, useTheme} from "@emotion/react";

import {calculateRemSize, flex} from "@pg-design/helpers-css";
import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {ViewType} from "../../../view_type/ViewType";

interface IProps {
    offerId: number;
    handleSetOfferId: (offerId: number | null) => void;
}

export const MapOfferExpandablePanelOfferSwitcher = (props: IProps) => {
    const theme = useTheme();
    const {isMobile} = useUserDevice();
    const offersListMap = useSelector((state: IRPStore) => state.offerListMap.list);
    const vendorOffersListMap = useSelector((state: IRPStore) => state.vendor.detail);
    const investmentOfferListMap = useSelector((state: IRPStore) => state.investmentOffer.list.offers);
    const viewType = useSelector((state: IRPStore) => state.viewType.current);
    const isInvestmentListMap = viewType === ViewType.FOR_INVESTMENT_LIST_MAP;
    const isVendorListMap = viewType === ViewType.VENDOR;
    const offersList = isInvestmentListMap ? investmentOfferListMap.offerList : isVendorListMap ? vendorOffersListMap.offers : offersListMap.offers;
    const offersCount = isInvestmentListMap ? investmentOfferListMap.count : isVendorListMap ? vendorOffersListMap.offersCount : offersListMap.count;

    const page = 1;
    const pageSize = offersCount;
    const offerId = props.offerId;

    const offersStartingPosition = page > 1 && pageSize ? (page - 1) * pageSize : 0;
    const offersWithPosition = offersList?.map((offer, index) => ({id: offer.id, position: offersStartingPosition + index, data: offer})) || [];
    const selectedOffer = offersWithPosition.find((offer) => offer.id === offerId);

    if (!selectedOffer) {
        throw new Error(`Offer ${offerId} is not available in query`);
    }
    const totalCount = offersCount as number;
    const readablePosition = selectedOffer.position + 1;

    const nextOfferPosition = selectedOffer.position + 1;
    const nextOffer = offersWithPosition.find((offer) => (readablePosition < totalCount ? offer.position === nextOfferPosition : offer.position === 0));
    const prevOfferPosition = selectedOffer.position - 1;
    const prevOffer = offersWithPosition.find((offer) => (readablePosition > 1 ? offer.position === prevOfferPosition : offer.position === totalCount - 1));
    const isSingleOffer = totalCount === 1;

    const handlers = {
        navToNext: () => {
            if (nextOffer) {
                props.handleSetOfferId(nextOffer.id);
            }
        },
        navToPrev: () => {
            if (prevOffer) {
                props.handleSetOfferId(prevOffer.id);
            }
        }
    };

    return (
        <div css={wrapper}>
            {!!prevOffer && !isSingleOffer && (
                <button type="button" onClick={handlers.navToPrev}>
                    <ChevronLeftIcon size={isMobile ? "1.6" : "3.6"} wrapperSize={isMobile ? "3.2" : "6.4"} wrapperColor={theme.colors.primary} />
                </button>
            )}
            <Text variant="body_copy_1" color={!isMobile ? "white" : undefined} align={!isMobile ? "center" : undefined} strong>
                {readablePosition}/{totalCount}
            </Text>
            {!!nextOffer && !isSingleOffer && (
                <button type="button" onClick={handlers.navToNext}>
                    <ChevronRightIcon size={isMobile ? "1.6" : "3.6"} wrapperSize={isMobile ? "3.2" : "6.4"} wrapperColor={theme.colors.primary} />
                </button>
            )}
        </div>
    );
};

const wrapper = css`
    ${flex("center", "center")};
    gap: ${calculateRemSize(1.5)};
    min-height: ${calculateRemSize(6)};
    max-height: ${calculateRemSize(6)};
    margin-left: auto;
`;
import React from "react";
import {useSelector} from "react-redux";
import {css, useTheme} from "@emotion/react";

import {calculateRemSize, flex} from "@pg-design/helpers-css";
import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {ViewType} from "../../../view_type/ViewType";

interface IProps {
    offerId: number;
    handleSetOfferId: (offerId: number | null) => void;
}

export const MapOfferExpandablePanelOfferSwitcher = (props: IProps) => {
    const theme = useTheme();
    const {isMobile} = useUserDevice();
    const offersListMap = useSelector((state: IRPStore) => state.offerListMap.list);
    const vendorOffersListMap = useSelector((state: IRPStore) => state.vendor.detail);
    const investmentOfferListMap = useSelector((state: IRPStore) => state.investmentOffer.list.offers);
    const viewType = useSelector((state: IRPStore) => state.viewType.current);
    const isInvestmentListMap = viewType === ViewType.FOR_INVESTMENT_LIST_MAP;
    const isVendorListMap = viewType === ViewType.VENDOR;
    const offersList = isInvestmentListMap ? investmentOfferListMap.offerList : isVendorListMap ? vendorOffersListMap.offers : offersListMap.offers;
    const offersCount = isInvestmentListMap ? investmentOfferListMap.count : isVendorListMap ? vendorOffersListMap.offersCount : offersListMap.count;

    const page = 1;
    const pageSize = offersCount;
    const offerId = props.offerId;

    const offersStartingPosition = page > 1 && pageSize ? (page - 1) * pageSize : 0;
    const offersWithPosition = offersList?.map((offer, index) => ({id: offer.id, position: offersStartingPosition + index, data: offer})) || [];
    const selectedOffer = offersWithPosition.find((offer) => offer.id === offerId);

    if (!selectedOffer) {
        throw new Error(`Offer ${offerId} is not available in query`);
    }
    const totalCount = offersCount as number;
    const readablePosition = selectedOffer.position + 1;

    const nextOfferPosition = selectedOffer.position + 1;
    const nextOffer = offersWithPosition.find((offer) => (readablePosition < totalCount ? offer.position === nextOfferPosition : offer.position === 0));
    const prevOfferPosition = selectedOffer.position - 1;
    const prevOffer = offersWithPosition.find((offer) => (readablePosition > 1 ? offer.position === prevOfferPosition : offer.position === totalCount - 1));
    const isSingleOffer = totalCount === 1;

    const handlers = {
        navToNext: () => {
            if (nextOffer) {
                props.handleSetOfferId(nextOffer.id);
            }
        },
        navToPrev: () => {
            if (prevOffer) {
                props.handleSetOfferId(prevOffer.id);
            }
        }
    };

    return (
        <div css={wrapper}>
            {!!prevOffer && !isSingleOffer && (
                <button type="button" onClick={handlers.navToPrev}>
                    <ChevronLeftIcon size={isMobile ? "1.6" : "3.6"} wrapperSize={isMobile ? "3.2" : "6.4"} wrapperColor={theme.colors.primary} />
                </button>
            )}
            <Text variant="body_copy_1" color={!isMobile ? "white" : undefined} align={!isMobile ? "center" : undefined} strong>
                {readablePosition}/{totalCount}
            </Text>
            {!!nextOffer && !isSingleOffer && (
                <button type="button" onClick={handlers.navToNext}>
                    <ChevronRightIcon size={isMobile ? "1.6" : "3.6"} wrapperSize={isMobile ? "3.2" : "6.4"} wrapperColor={theme.colors.primary} />
                </button>
            )}
        </div>
    );
};

const wrapper = css`
    ${flex("center", "center")};
    gap: ${calculateRemSize(1.5)};
    min-height: ${calculateRemSize(6)};
    max-height: ${calculateRemSize(6)};
    margin-left: auto;
`;
